module.exports = __webpack_public_path__ + "static/media/afm.8f3ec592.png";